import { IncomeAmountAmountType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";

export type OrphanOrWidowIncomeFormType = {
  readonly degree: typeof IncomeAmountAmountType.orphan_pension | typeof IncomeAmountAmountType.widow_pension;
  readonly amountValueOrphan?: number;
  readonly amountValueWidow?: number;
};

export const getOrphanOrWidowIncomeFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<OrphanOrWidowIncomeFormType> = (t) => {
  const createConditionalSchema = (degree: IncomeAmountAmountType) => {
    return number()
      .transform((value, original) => (original === "" ? undefined : value))
      .when("degree", ([degreeValue], schema) => {
        if (degreeValue === degree) {
          return schema
            .required(t(Resources.Validation.Required))
            .min(1, t(Resources.Validation.Number.MoreThen, { count: 0 }))
            .typeError(t(Resources.Validation.Required));
        }
        return schema.default(0); // pokud není tento degree vybrán, dáme 0
      });
  };

  return object({
    degree: string()
      .oneOf([IncomeAmountAmountType.orphan_pension, IncomeAmountAmountType.widow_pension])
      .required(t(Resources.Validation.Required)),
    amountValueOrphan: createConditionalSchema(IncomeAmountAmountType.orphan_pension),
    amountValueWidow: createConditionalSchema(IncomeAmountAmountType.widow_pension),
  }).defined();
};
